<!-- class students list -->
<template>
  <div v-if="hasPermission('Manage media_Create')">
    <div class="upload-entry">
      <el-popover
        v-model="uploadMenuVisible"
        placement="right"
        trigger="click"
        :visible-arrow="false"
        popper-class="moments-upload-menu"
      >
        <div class="upload-menu-list">
          <div class="upload-menu-item" @click="handleUploadTypeSelect('photo')">Upload photo</div>
          <div class="upload-menu-item" @click="handleUploadTypeSelect('video')">Upload video</div>
        </div>
        <div slot="reference" class="upload-reference">
          <span @mousedown="btnClick">
            <slot></slot>
          </span>
        </div>
      </el-popover>
    </div>
    <el-upload
      ref="photoUpload"
      class="upload-trigger"
      action=""
      accept="image/jpeg,image/png"
      :auto-upload="false"
      :on-change="uploadPhotoFileChange"
      :multiple="true"
      :file-list="fileListTemp"
      :limit="10"
      :on-exceed="onExceed"
    />
    <el-upload
      ref="videoUpload"
      class="upload-trigger"
      action=""
      accept="video/mp4,video/webm,video/ogg,video/ogv,video/mov,video/m4v,video/3gp,video/3g2"
      :auto-upload="false"
      :on-change="uploadVideoFileChange"
      :multiple="true"
      :file-list="fileListTemp"
      :limit="10"
      :on-exceed="onExceed"
    />
    <gg-Dialog :visible.sync="studentSelecterShow" width="580px" ref="studentSelecter">
      <div slot="title">Select student</div>
      <div class="ct" v-loading="loading">
        <div class="values" @click.self="valuesClick">
          <div class="value" v-for="item in selectedTemp" :key="item.id">
            <span
              v-if="item.photo"
              class="avatar"
              :style="'background-image:url(' + item.photo + ')'"
            ></span>
            <span v-else class="icon-text">{{ item.name.toUpperCase() | getIconText }}</span>
            <span class="name">{{ item.name }}</span>
            <el-button
              type="text"
              icon="el-icon-error"
              @click="checkItem(item)"
              v-if="item.id != studentId"
            ></el-button>
          </div>
          <div class="ipt-search">
            <input
              type="text"
              ref="ipt-search-input"
              :style="'width:' + searchInputW + 'px'"
              v-model="keywords"
              autocomplete="off"
            />
            <span class="ipt-search-val" ref="ipt-search-val">{{ keywords }}</span>
          </div>
          <div
            class="placeholder"
            v-if="keywords.length === 0 && selectedTemp.length === 0"
            @click.self="valuesClick"
          >
            Type a name or email address
          </div>
        </div>
        <div class="options">
          <div class="tit">SEARCH RESULTS</div>
          <div class="student-option-list">
            <div class="item" @click="checkAll" v-if="options.length > 0">
              <span class="checkbox" :class="{ checked: isCheckAll }">
                <i class="el-icon-check"></i>
              </span>
              <span
                class="avatar"
                :style="
                  'background-image:url(' + require('@/assets/images/icons/student-all.png') + ')'
                "
              ></span>
              <div class="wd">
                <div class="wd-main">
                  <span class="name">Select all</span>
                </div>
              </div>
            </div>
            <div class="item" style="cursor: text" v-else>
              <span class="avatar"><i class="iconfont iconyiquxiao" /></span>
              <div class="wd">
                <div class="wd-main">
                  <span class="name">No results</span>
                </div>
              </div>
            </div>
            <div
              class="item"
              :class="{ disabled: item.id == studentId }"
              v-for="item in options"
              :key="item.id"
              @click="checkItem(item)"
            >
              <span
                class="checkbox"
                :class="{ checked: selectedTemp.find((o) => o.id == item.id) }"
              >
                <i class="el-icon-check"></i>
              </span>
              <span
                v-if="item.photo"
                class="avatar"
                :style="'background-image:url(' + item.photo + ')'"
              ></span>
              <span v-else class="icon-text">{{ item.name.toUpperCase() | getIconText }}</span>
              <div class="wd">
                <div class="wd-main">
                  <span class="name">{{ item.name }}</span>
                  <span class="mail">-</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <gg-cancel-button @click="close">Cancel</gg-cancel-button>
        <gg-submit-button :disabled="selectedTemp.length == 0" @click="doUpload"
          >Upload</gg-submit-button
        >
      </span>
    </gg-Dialog>
    <Snackbar :visible.sync="snackbarData.visible" :content="snackbarData.content" />
    <div class="progress-box" v-if="uploading">
      <div class="wd">{{ uploadProgressTitle }}</div>
      <div class="cur">{{ progress.cur }} of {{ progress.total }}</div>
      <baseButton @click="stopUpload" type="primary">Stop</baseButton>
      <div class="progress-bar">
        <span class="ratio" :style="'width:' + progress.ratio + '%'"></span>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { Ajax } from '@/common'
import axios from 'axios'
import { mapState } from 'vuex'
import { hasPermission } from './../utils/utils.js'
import imageCompression from 'browser-image-compression'
import moment from 'moment'
import { getVideoMetadata, transcodeVideoForUpload } from './videoTranscode'

const sharedUploadUiState = Vue.observable({
  snackbarData: {
    visible: false,
    content: ''
  },
  uploading: false,
  processingVideo: false,
  progress: {
    total: 0,
    cur: 0,
    ratio: 0
  },
  currentUploadType: ''
})

export default {
  props: {
    classId: {
      default: '',
      type: String
    },
    studentId: {
      default: '',
      type: String
    },
    albumId: {
      default: '',
      type: String
    }
  },
  data() {
    return {
      studentSelecterShow: false,
      loading: false,
      options: [],
      selected: [],
      selectedTemp: [],
      fileListTemp: [],
      uploadMenuVisible: false,
      keywords: '',
      searchInputW: 10,
      pendingVideoValidationTimer: null,
      pendingVideoValidationToken: 0,
      stopRequested: false,
      completedUploadCount: 0,
      activeUploadController: null,
      activeCompressionTask: null,
      uploadResetTimer: null
    }
  },
  computed: {
    isCheckAll() {
      return this.selectedTemp.length !== 0 && this.selectedTemp.length === this.options.length
    },
    uploadProgressTitle() {
      if (this.currentUploadType === 'video') {
        return this.progress.total > 1 ? 'Uploading videos ...' : 'Uploading video ...'
      }
      return this.progress.total > 1 ? 'Uploading photos ...' : 'Uploading photo ...'
    },
    uploadResultLabel() {
      if (this.currentUploadType === 'video') {
        return this.completedUploadCount > 1 ? 'videos have' : 'video has'
      }
      return this.completedUploadCount > 1 ? 'photos have' : 'photo has'
    },
    snackbarData() {
      return sharedUploadUiState.snackbarData
    },
    uploading: {
      get() {
        return sharedUploadUiState.uploading
      },
      set(val) {
        sharedUploadUiState.uploading = val
      }
    },
    processingVideo: {
      get() {
        return sharedUploadUiState.processingVideo
      },
      set(val) {
        sharedUploadUiState.processingVideo = val
      }
    },
    progress: {
      get() {
        return sharedUploadUiState.progress
      },
      set(val) {
        sharedUploadUiState.progress = val
      }
    },
    currentUploadType: {
      get() {
        return sharedUploadUiState.currentUploadType
      },
      set(val) {
        sharedUploadUiState.currentUploadType = val
      }
    },

    ...mapState({
      user: (state) => state.user
    })
  },
  watch: {
    keywords: function () {
      // console.log(this.$refs['ipt-search-val'].offsetWidth)
      this.$nextTick(() => {
        this.searchInputW = this.$refs['ipt-search-val']
          ? this.$refs['ipt-search-val'].offsetWidth + 6
          : 10
      })
      const res = this.keywords.trim().toLowerCase()
      if (res == '') {
        this.options = [...this.optionsAll]
      } else {
        this.options = this.optionsAll.filter((o) => {
          const _name = o.name.toLowerCase()
          return _name.indexOf(res) >= 0
        })
      }
    }
  },
  filters: {
    getIconText(text) {
      if (!text) {
        return ''
      }
      const arr = text.split(' ')
      const first = arr[0].substr(0, 1)
      if (arr.length > 1) {
        const last = arr[arr.length - 1].substr(0, 1)
        return `${first}${last}`
      }
      return first
    }
  },
  created() {
    this.fetchStudents()
  },
  methods: {
    hasPermission,
    getMaxVideoUploadSize() {
      return 2 * 1024 * 1024 * 1024
    },
    valuesClick() {
      this.$refs['ipt-search-input'].focus()
    },
    btnClick() {
      console.log('uploadClick')
      this.fileListTemp = []
    },
    handleUploadTypeSelect(type) {
      this.uploadMenuVisible = false
      this.currentUploadType = type
      this.fileListTemp = []
      this.clearPendingVideoValidation()
      const uploadRef = type === 'video' ? 'videoUpload' : 'photoUpload'
      this.$nextTick(() => {
        const upload = this.$refs[uploadRef]
        if (!upload || !upload.$el) {
          return
        }
        const input = upload.$el.querySelector('input')
        if (input) {
          input.value = ''
          input.click()
        }
      })
    },
    open() {
      this.studentSelecterShow = true

      this.initDefault()
    },
    initDefault() {
      this.selected = []
      this.selectedTemp = []
      if (this.studentId.length > 0) {
        console.log(this.studentId, 'this.options', this.options)
        const _data = this.options.find((o) => o.id == this.studentId)
        this.selected = [_data]
        this.selectedTemp = [_data]
      }
    },
    close() {
      this.studentSelecterShow = false
      this.keywords = ''
    },
    checkAll() {
      if (this.isCheckAll) {
        if (this.studentId.length > 0) {
          const _data = this.options.find((o) => o.id == this.studentId)
          this.selectedTemp = [_data]
        } else {
          this.selectedTemp = []
        }
      } else {
        this.selectedTemp = [...this.options]
      }
      this.keywords = ''
    },
    checkItem(item) {
      if (item.id == this.studentId) {
        return
      }
      const _i = this.selectedTemp.findIndex((o) => o.id == item.id)
      if (_i >= 0) {
        // 鍙栨秷閫変腑
        this.selectedTemp.splice(_i, 1)
      } else {
        // 閫変腑
        this.selectedTemp.push(item)
      }
      this.keywords = ''
    },
    fetchStudents() {
      this.loading = true
      Ajax.get('/usermanage/student/getStudentByClassId', {
        classId: this.classId
      })
        .then((res) => {
          this.loading = false
          if (res.code == '0000') {
            this.options = res.data.map((o) => {
              return {
                id: o.id,
                photo: o.photo,
                name: o.firstName + ' ' + o.lastName
              }
            })
            this.optionsAll = [...this.options]
            console.log('this.options', this.options)
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
    createUploadStoppedError() {
      const error = new Error('Upload stopped')
      error.code = 'UPLOAD_STOPPED'
      return error
    },
    isUploadStoppedError(error) {
      return Boolean(
        error &&
        (error.code === 'UPLOAD_STOPPED' ||
          error.name === 'AbortError' ||
          (typeof axios.isCancel === 'function' && axios.isCancel(error)))
      )
    },
    ensureUploadActive() {
      if (this.stopRequested || !this.uploading) {
        throw this.createUploadStoppedError()
      }
    },
    abortActiveUploadRequest() {
      if (this.activeUploadController) {
        this.activeUploadController.abort()
        this.activeUploadController = null
      }
    },
    cancelActiveCompressionTask() {
      if (this.activeCompressionTask && this.activeCompressionTask.cancel) {
        this.activeCompressionTask.cancel()
      }
      this.activeCompressionTask = null
    },
    async runCancelableRequest(requestFn) {
      this.ensureUploadActive()
      const controller = typeof AbortController !== 'undefined' ? new AbortController() : null
      this.activeUploadController = controller
      try {
        return await requestFn(controller ? controller.signal : undefined)
      } finally {
        if (this.activeUploadController === controller) {
          this.activeUploadController = null
        }
      }
    },
    finishUpload(stopped = false) {
      this.uploading = false
      this.processingVideo = false
      if (!stopped) {
        this.stopRequested = false
      }
      this.abortActiveUploadRequest()
      this.cancelActiveCompressionTask()
      if (this.uploadResetTimer) {
        clearTimeout(this.uploadResetTimer)
      }
      if (stopped) {
        if (this.completedUploadCount > 0) {
          this.handleSnack(`${this.completedUploadCount} ${this.uploadResultLabel} been uploaded`)
        } else {
          this.handleSnack('Upload stopped')
        }
      }
      this.$emit('onFinish')
      this.uploadResetTimer = setTimeout(() => {
        this.fileListTemp = []
        this.currentUploadType = ''
        this.progress = {
          total: 0,
          cur: 0,
          ratio: 0
        }
        this.completedUploadCount = 0
        this.uploadResetTimer = null
      }, 500)
    },
    stopUpload() {
      this.stopRequested = true
      this.abortActiveUploadRequest()
      this.cancelActiveCompressionTask()
      this.finishUpload(true)
    },
    async doUpload() {
      try {
        const invalidVideoFiles = await this.getInvalidDurationVideoFiles(this.fileListTemp)
        if (invalidVideoFiles.length > 0) {
          this.cancelInvalidVideoUpload(invalidVideoFiles)
          return
        }
        this.selected = [...this.selectedTemp]
        var i = 0
        this.studentSelecterShow = false
        this.keywords = ''
        this.stopRequested = false
        this.completedUploadCount = 0
        this.uploading = true
        while (i < this.fileListTemp.length && this.uploading) {
          this.ensureUploadActive()
          let regx_video = ['mp4', 'webm', 'ogg', 'ogv', 'mov', 'm4v', '3gp', '3g2']
          if (
            regx_video.some((video) =>
              this.fileListTemp[i].name.toLowerCase().endsWith(`.${video}`)
            )
          ) {
            await this.fetchUploadVideo(this.fileListTemp[i], i)
          } else {
            await this.fetchUpload(this.fileListTemp[i], i)
          }
          i++
        }
        if (!this.stopRequested) {
          this.finishUpload(false)
        }
      } catch (error) {
        if (!this.isUploadStoppedError(error)) {
          this.finishUpload(false)
          throw error
        }
      }
    },
    async fetchUploadVideo(_file, _i) {
      var t = this
      console.log('fetchUploadVideo', _file)
      try {
        this.ensureUploadActive()
        const uploadFileRaw = await this.prepareVideoForUpload(_file.raw, _i)
        this.ensureUploadActive()
        console.log('uploadFileRaw', uploadFileRaw.name)
        const uploadSts = await this.getVideoUploadSts(uploadFileRaw.name)
        this.ensureUploadActive()
        const ossUploadResult = await this.uploadVideoToOss(uploadFileRaw, uploadSts, _i)
        this.ensureUploadActive()
        const upres = await this.completeVideoUpload({
          objectKey: uploadSts.objectKey,
          originalFileName: uploadFileRaw.name,
          size: uploadFileRaw.size,
          contentType: uploadFileRaw.type || 'video/mp4',
          etag: ossUploadResult.etag
        })
        var _students = this.selected.map((o) => {
          return {
            classId: this.classId,
            studentId: o.id
          }
        })
        var _data = {
          mediaList: [
            {
              fileDisplayName: upres.data.fileDisplayName,
              path: upres.data.filePath,
              publishId: t.user.userId,
              schoolId: t.user.locationId,
              topic: '',
              uploadFrom: 'web browser',
              uploadTime: moment().format('YYYY-MM-DD'),
              mediaType: 1,
              imagePath: upres.data.imagePath
            }
          ],
          studentInfoList: _students
        }
        var _path = '/moments/media/uploadBatch'
        if (this.albumId.length > 0) {
          _data = {
            albumId: this.albumId,
            mediaList: [
              {
                fileDisplayName: upres.data.fileDisplayName,
                path: upres.data.filePath,
                publishId: t.user.userId,
                schoolId: t.user.locationId,
                topic: '',
                uploadFrom: 'web',
                uploadTime: moment().format('YYYY-MM-DD')
              }
            ],
            studentInfoList: _students
          }
          _path = '/moments/albums/upload'
        }
        await this.runCancelableRequest((signal) =>
          Ajax.post(_path, _data, { signal }).catch((err) => {
            console.log(err)
            throw err
          })
        )
        this.completedUploadCount++
        this.$emit('uploadSuccess')
      } catch (err) {
        if (this.isUploadStoppedError(err)) {
          return
        }
        console.log(err)
        this.handleSnack(this.getVideoUploadFailureMessage(err))
        throw err
      }
    },
    async fetchUpload(_file, _i) {
      var t = this

      try {
        this.ensureUploadActive()
        const options = {
          maxSizeMB: 1,
          alwaysKeepResolution: true,
          maxWidthOrHeight: 1920,
          useWebWorker: false,
          fileType: 'image/jpeg',
          onProgress: (process) => {
            this.setCompressionProgress(_i, process)
          }
        }
        console.log('file', _file)
        this.setCompressionProgress(_i, 0)
        const compressedFileRaw = await imageCompression(_file.raw, options)
        this.ensureUploadActive()
        this.setCompressionProgress(_i, 100)
        // 处理压缩后的文件，例如上传到服务器
        // console.log("Compressed file:", compressedFileRaw);
        const compressedFile = Object.assign(_file, {
          raw: compressedFileRaw,
          size: compressedFileRaw.size
        })
        console.log('Compressed file:', compressedFileRaw, compressedFile)
        let formData = new FormData()
        formData.append('file', compressedFile)
        formData.append('multipartFile', compressedFileRaw) // _file.raw
        var upres = await this.runCancelableRequest((signal) =>
          Ajax.post('/media/public/file/uploadExt', formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
            signal,
            onUploadProgress: (progressEvent) => {
              let process = ((progressEvent.loaded / progressEvent.total) * 100) | 0
              this.setUploadProgress(_i, process)
            }
          }).catch((err) => {
            console.log(err)
            throw err
          })
        )
        if (upres.code === '0000') {
          var _students = this.selected.map((o) => {
            return {
              classId: this.classId,
              studentId: o.id
            }
          })

          var _data = {
            mediaList: [
              {
                fileDisplayName: upres.data.fileDisplayName,
                path: upres.data.filePath,
                publishId: t.user.userId,
                schoolId: t.user.locationId,
                topic: '',
                uploadFrom: 'web browser',
                uploadTime: moment().format('YYYY-MM-DD')
              }
            ],
            studentInfoList: _students
          }
          var _path = '/moments/media/uploadBatch'
          if (this.albumId.length > 0) {
            // 使用相册中的上传接口
            _data = {
              albumId: this.albumId,
              mediaList: [
                {
                  fileDisplayName: upres.data.fileDisplayName,
                  path: upres.data.filePath,
                  publishId: t.user.userId,
                  schoolId: t.user.locationId,
                  topic: '',
                  uploadFrom: 'web',
                  uploadTime: moment().format('YYYY-MM-DD')
                }
              ],
              studentInfoList: _students
            }
            _path = '/moments/albums/upload'
          }
          var upres = await this.runCancelableRequest((signal) =>
            Ajax.post(_path, _data, { signal }).catch((err) => {
              console.log(err)
              throw err
            })
          )
          this.completedUploadCount++
          this.$emit('uploadSuccess')
        }
        if (upres.code === '9999') {
          this.$confirm(
            'The maximum amount of files that can be uploaded is 10.',
            'Maximum number of files exceeded',
            {
              showConfirmButton: false,
              showCancelButton: false,
              customClass: 'gg_confirm'
            }
          )
        }
      } catch (error) {
        if (this.isUploadStoppedError(error)) {
          return
        }
        console.error('Error compressing image:', error)
      }
    },
    uploadPhotoFileChange(file, fileList) {
      this.clearPendingVideoValidation()
      this.currentUploadType = 'photo'
      this.uploadFileChange(file, fileList)
    },
    uploadVideoFileChange(file, fileList) {
      console.log('uploadVideoFileChange', file, fileList)
      if (this.isFirefoxBrowser()) {
        this.cancelFirefoxVideoUpload()
        return
      }
      this.currentUploadType = 'video'
      const validationToken = ++this.pendingVideoValidationToken
      const nextFileList = [...fileList]
      if (this.pendingVideoValidationTimer) {
        clearTimeout(this.pendingVideoValidationTimer)
      }
      this.pendingVideoValidationTimer = setTimeout(async () => {
        if (validationToken !== this.pendingVideoValidationToken) {
          return
        }
        const invalidDurationFileNames = await this.getInvalidDurationVideoFiles(nextFileList)
        if (validationToken !== this.pendingVideoValidationToken) {
          return
        }
        const exceededFileNames = this.getExceededTotalSizeVideoFiles(nextFileList)
        if (invalidDurationFileNames.length > 0) {
          await this.cancelInvalidVideoUpload(invalidDurationFileNames)
          if (
            validationToken === this.pendingVideoValidationToken &&
            exceededFileNames.length > 0
          ) {
            await this.cancelExceededTotalSizeVideoUpload(exceededFileNames)
          }
          this.clearPendingVideoValidation()
          return
        }
        if (exceededFileNames.length > 0) {
          await this.cancelExceededTotalSizeVideoUpload(exceededFileNames)
          this.clearPendingVideoValidation()
          return
        }
        this.clearPendingVideoValidation()
        this.uploadFileChange(file, nextFileList)
      }, 0)
    },
    uploadFileChange(file, fileList) {
      console.log('准备上传', file, fileList)
      this.fileListTemp = fileList
      this.open()
    },
    onExceed(files, fileList) {
      // this.handleSnack("Maximum upload size exceeded");
      this.$confirm(
        'The maximum amount of files that can be uploaded is 10.',
        'Maximum number of files exceeded',
        {
          showConfirmButton: false,
          showCancelButton: false,
          customClass: 'gg_confirm'
        }
      )
    },
    handleSnack(content) {
      this.snackbarData.content = content
      this.snackbarData.visible = true
    },
    clearPendingVideoValidation() {
      if (this.pendingVideoValidationTimer) {
        clearTimeout(this.pendingVideoValidationTimer)
        this.pendingVideoValidationTimer = null
      }
      this.pendingVideoValidationToken += 1
    },
    setFileProgress(index, ratio) {
      if (!this.uploading && !this.processingVideo) {
        return
      }
      this.progress = {
        total: this.fileListTemp.length,
        cur: index + 1,
        ratio: Math.min(100, Math.max(0, ratio))
      }
    },
    getStageProgress(process, start, end) {
      const normalizedProcess = Math.min(100, Math.max(0, process || 0))
      return Math.round(start + ((end - start) * normalizedProcess) / 100)
    },
    setCompressionProgress(index, process) {
      this.setFileProgress(index, this.getStageProgress(process, 0, 50))
    },
    setUploadProgress(index, process) {
      this.setFileProgress(index, this.getStageProgress(process, 50, 100))
    },
    getVideoUploadFailureMessage(error) {
      const message = (error && error.message && String(error.message)) || ''
      const normalizedMessage = message.toLowerCase()
      if (
        normalizedMessage.indexOf('not supported in this browser') >= 0 ||
        normalizedMessage.indexOf('not supported in this environment') >= 0
      ) {
        return 'Video transcoding is not supported in this browser.'
      }
      if (
        normalizedMessage.indexOf('transcod') >= 0 ||
        normalizedMessage.indexOf('selected codec or media') >= 0 ||
        normalizedMessage.indexOf('output buffer') >= 0
      ) {
        return 'Video transcoding failed.'
      }
      return 'Video upload failed'
    },
    async getInvalidDurationVideoFiles(fileList) {
      const invalidFiles = []
      const minDuration = 10
      const maxDuration = 181
      for (let i = 0; i < fileList.length; i++) {
        const fileItem = fileList[i]
        const rawFile = fileItem && fileItem.raw
        if (!rawFile || !this.isVideoFile(fileItem.name || rawFile.name || '')) {
          continue
        }
        try {
          const meta = await getVideoMetadata(rawFile)
          if (meta.duration <= minDuration || meta.duration >= maxDuration) {
            invalidFiles.push(fileItem.name || rawFile.name || 'Unknown file')
          }
        } catch (error) {
          invalidFiles.push(fileItem.name || rawFile.name || 'Unknown file')
        }
      }
      return invalidFiles
    },
    getExceededTotalSizeVideoFiles(fileList) {
      const maxVideoUploadSize = this.getMaxVideoUploadSize()
      const totalSize = fileList.reduce((sum, fileItem) => {
        const rawFile = fileItem && fileItem.raw
        return sum + (rawFile ? rawFile.size || 0 : 0)
      }, 0)
      if (totalSize <= maxVideoUploadSize) {
        return []
      }
      return fileList.map((fileItem) => fileItem.name || 'Unknown file')
    },
    cancelExceededTotalSizeVideoUpload(fileNames) {
      this.uploading = false
      this.processingVideo = false
      this.currentUploadType = ''
      this.fileListTemp = []
      this.studentSelecterShow = false
      this.keywords = ''
      if (this.$refs.videoUpload) {
        this.$refs.videoUpload.clearFiles()
      }
      return this.$confirm(
        `The total size of selected videos exceeds the maximum limit of 2GB.<br><br>Files contributing to the limit:<br><br>${fileNames.join(
          '<br>'
        )}`,
        'Total upload size exceeded',
        {
          dangerouslyUseHTMLString: true,
          showConfirmButton: false,
          showCancelButton: false,
          showClose: true,
          closeOnClickModal: true,
          customClass: 'gg_confirm total_size_confirm'
        }
      )
    },
    cancelInvalidVideoUpload(fileNames) {
      this.uploading = false
      this.processingVideo = false
      this.currentUploadType = ''
      this.fileListTemp = []
      this.studentSelecterShow = false
      this.keywords = ''
      if (this.$refs.videoUpload) {
        this.$refs.videoUpload.clearFiles()
      }
      return this.$confirm(
        `The video duration must be greater than 10 seconds and less than 180 seconds.<br><br>Files not meeting the duration requirement:<br>${fileNames.join(
          '<br>'
        )}`,
        'Video duration not supported',
        {
          dangerouslyUseHTMLString: true,
          showConfirmButton: false,
          showCancelButton: false,
          showClose: true,
          closeOnClickModal: true,
          customClass: 'gg_confirm'
        }
      )
    },
    cancelFirefoxVideoUpload() {
      this.clearPendingVideoValidation()
      this.uploading = false
      this.processingVideo = false
      this.currentUploadType = ''
      this.fileListTemp = []
      this.studentSelecterShow = false
      this.keywords = ''
      if (this.$refs.videoUpload) {
        this.$refs.videoUpload.clearFiles()
      }
      return this.$confirm(
        'Video upload is only supported in Chrome and Chromium-based browsers.',
        'Video upload not supported',
        {
          showConfirmButton: false,
          showCancelButton: false,
          showClose: true,
          closeOnClickModal: true,
          customClass: 'gg_confirm'
        }
      )
    },
    async completeVideoUpload(data) {
      const response = await this.runCancelableRequest((signal) =>
        Ajax.post('/media/public/file/video/complete', data, { signal })
      )
      if (!response || response.code !== '0000') {
        throw new Error((response && response.message) || 'Failed to complete video upload')
      }
      return response
    },
    async getVideoUploadSts(originalFileName) {
      const response = await this.runCancelableRequest((signal) =>
        Ajax.post(
          '/media/public/file/video/sts',
          {
            originalFileName
          },
          { signal }
        )
      )
      if (!response || response.code !== '0000' || !response.data) {
        throw new Error((response && response.message) || 'Failed to get video upload STS')
      }
      return {
        accessKeyId: response.data.accessKeyId,
        accessKeySecret: response.data.accessKeySecret,
        securityToken: response.data.securityToken,
        bucketName: response.data.bucketName,
        endpoint: response.data.endpoint,
        region: response.data.region,
        objectKey: response.data.objectKey
      }
    },
    async uploadVideoToOss(file, stsData, index) {
      const uploadUrl = this.getOssUploadUrl(stsData)
      const requestDate = new Date().toUTCString()
      const contentType = file.type || 'video/mp4'
      const authorization = await this.getOssAuthorization({
        accessKeyId: stsData.accessKeyId,
        accessKeySecret: stsData.accessKeySecret,
        bucketName: stsData.bucketName,
        objectKey: stsData.objectKey,
        securityToken: stsData.securityToken,
        contentType,
        requestDate
      })
      console.log('Uploading to OSS with URL:', uploadUrl)
      const response = await this.runCancelableRequest((signal) =>
        axios.put(uploadUrl, file, {
          signal,
          headers: {
            'Content-Type': contentType,
            'x-oss-date': requestDate,
            'x-oss-security-token': stsData.securityToken,
            Authorization: authorization
          },
          onUploadProgress: (progressEvent) => {
            let process =
              progressEvent.total && progressEvent.total > 0
                ? ((progressEvent.loaded / progressEvent.total) * 100) | 0
                : 0
            this.setUploadProgress(index, process)
          }
        })
      )
      return {
        etag: this.normalizeOssEtag(response.headers && response.headers.etag)
      }
    },
    getOssUploadUrl(stsData) {
      const endpoint = (stsData.endpoint || '').replace(/\/+$/, '')
      const host = endpoint.replace(/^https?:\/\//, '')
      const encodedObjectKey = stsData.objectKey
        .split('/')
        .map((item) => encodeURIComponent(item))
        .join('/')
      return `https://${stsData.bucketName}.${host}/${encodedObjectKey}`
    },
    async getOssAuthorization({
      accessKeyId,
      accessKeySecret,
      bucketName,
      objectKey,
      securityToken,
      contentType,
      requestDate
    }) {
      const canonicalHeaders = this.getOssCanonicalHeaders({
        requestDate,
        securityToken
      })
      const canonicalResource = `/${bucketName}/${objectKey}`
      const stringToSign = [
        'PUT',
        '',
        contentType,
        requestDate,
        canonicalHeaders + canonicalResource
      ].join('\n')
      const signature = await this.signOssString(accessKeySecret, stringToSign)
      return `OSS ${accessKeyId}:${signature}`
    },
    getOssCanonicalHeaders({ requestDate, securityToken }) {
      return [`x-oss-date:${requestDate}`, `x-oss-security-token:${securityToken}`]
        .sort()
        .join('\n')
        .concat('\n')
    },
    async signOssString(secret, message) {
      if (!window.crypto || !window.crypto.subtle || typeof TextEncoder === 'undefined') {
        throw new Error('Current browser does not support OSS upload')
      }
      const encoder = new TextEncoder()
      const cryptoKey = await window.crypto.subtle.importKey(
        'raw',
        encoder.encode(secret),
        {
          name: 'HMAC',
          hash: { name: 'SHA-1' }
        },
        false,
        ['sign']
      )
      const signatureBuffer = await window.crypto.subtle.sign(
        'HMAC',
        cryptoKey,
        encoder.encode(message)
      )
      return this.arrayBufferToBase64(signatureBuffer)
    },
    arrayBufferToBase64(buffer) {
      let binary = ''
      const bytes = new Uint8Array(buffer)
      for (let i = 0; i < bytes.byteLength; i++) {
        binary += String.fromCharCode(bytes[i])
      }
      return window.btoa(binary)
    },
    normalizeOssEtag(etag) {
      if (!etag) {
        return ''
      }
      return etag.replace(/^"+|"+$/g, '')
    },
    isFirefoxBrowser() {
      return typeof navigator !== 'undefined' && /firefox/i.test(navigator.userAgent || '')
    },
    async prepareVideoForUpload(file, index) {
      this.ensureUploadActive()
      if (!file) {
        this.setCompressionProgress(index, 100)
        return file
      }

      this.processingVideo = true
      this.setCompressionProgress(index, 0)
      let cancellationHandled = false
      let rejectCancellation = null
      const cancellationPromise = new Promise((_, reject) => {
        rejectCancellation = reject
      })
      this.activeCompressionTask = {
        cancel: () => {
          cancellationHandled = true
          if (rejectCancellation) {
            rejectCancellation(this.createUploadStoppedError())
          }
        }
      }
      const transcodePromise = transcodeVideoForUpload({
        file,
        stopRequested: () => this.stopRequested || !this.uploading,
        onProgress: ({ progress }) => {
          this.setCompressionProgress(index, progress)
        }
      }).catch((error) => {
        if (cancellationHandled && this.isUploadStoppedError(error)) {
          return null
        }
        throw error
      })

      try {
        const result = await Promise.race([transcodePromise, cancellationPromise])
        this.ensureUploadActive()
        this.setCompressionProgress(index, 100)
        if (!result || !result.file) {
          throw this.createUploadStoppedError()
        }
        return result.file
      } finally {
        this.activeCompressionTask = null
        this.processingVideo = false
      }
    },
    isVideoFile(fileName) {
      const normalizedName = (fileName || '').toLowerCase()
      return ['.mp4', '.webm', '.ogg', '.ogv', '.mov', '.m4v', '.3gp', '.3g2'].some((extension) =>
        normalizedName.endsWith(extension)
      )
    }
  }
}
</script>
<style lang="less">
.moments-upload-menu {
  min-width: 132px;
  padding: 6px 0;
  margin-top: 4px;
}

.el-message-box.total_size_confirm {
  width: 560px;
}

.total_size_confirm > .el-message-box__header {
  padding: 20px 24px 0;
}

.total_size_confirm > .el-message-box__header > .el-message-box__title {
  font-size: 16px;
  line-height: 24px;
  color: #3c4043;
  font-weight: 500;
}

.total_size_confirm > .el-message-box__content {
  padding: 20px 24px 24px;
}

.total_size_confirm .el-message-box__message {
  font-size: 14px;
  line-height: 24px;
  color: #3c4043;
}
</style>
<style lang="less" scoped>
/deep/ .el-upload-list {
  display: none;
}

.upload-entry {
  display: inline-block;

  /deep/ .el-popover__reference-wrapper {
    display: inline-block;
  }
}

.upload-reference {
  display: inline-block;
}

.upload-trigger {
  width: 0;
  height: 0;
  overflow: hidden;
  opacity: 0;
  position: absolute;
  pointer-events: none;
}

.upload-menu-list {
  .upload-menu-item {
    height: 40px;
    line-height: 40px;
    padding: 0 16px;
    font-size: 14px;
    color: #202124;
    cursor: pointer;

    &:hover {
      background: #f5f5f5;
    }
  }
}

.progress-box {
  position: fixed;
  z-index: 999;
  bottom: 16px;
  left: 50%;
  transform: translate(-50%, 0);
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
  width: 290px;
  box-sizing: border-box;
  background: #fff;
  border-radius: 4px;
  padding: 12px 16px;
  overflow: hidden;

  .wd {
    line-height: 20px;
    height: 20px;
    color: #202124;
    font-size: 14px;
  }

  .cur {
    line-height: 20px;
    margin-top: 4px;
    color: #5f6368;
    font-size: 14px;
  }

  .progress-bar {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 8px;
    background: #e0e0e0;

    .ratio {
      float: left;
      height: 100%;
      background: #1a73e8;
    }
  }

  .base-button {
    position: absolute;
    right: 10px;
    bottom: 16px;
  }
}

.value {
  display: inline-block;
  height: 32px;
  line-height: 30px;
  padding: 0 4px;
  border: 1px solid #e0e0e0;
  border-radius: 15px;
  font-size: 0;
  margin: 0 8px 4px 0;
  cursor: default;

  .avatar {
    width: 24px;
    height: 24px;
    border-radius: 100%;
    background-position: center center;
    background-size: cover;
    background-repeat: no-repeat;
    vertical-align: middle;
    display: inline-block;
    background-color: #eee;
  }

  .icon-text {
    border-radius: 50%;
    text-align: center;
    align-items: center;
    justify-content: center;
    background: #b4b4b4;
    color: #fff;
    width: 24px;
    height: 24px;
    line-height: 24px;
    font-size: 12px;
    font-family: 'opensans-semibold';
    vertical-align: middle;
    display: inline-block;
  }

  .name {
    font-size: 14px;
    color: #202124;
    margin-left: 8px;
    vertical-align: middle;
  }

  .el-button {
    padding: 0;
    vertical-align: middle;
    color: #5f6368;
    font-size: 20px;
    margin-left: 8px;
  }
}

.ct {
  padding: 24px;

  .values {
    padding: 4px 0;
    border-bottom: 1px solid #1a73e8;
    min-height: 41px;
    font-size: 0;
    cursor: text;
    position: relative;

    .ipt-search {
      display: inline-block;
      vertical-align: middle;
      position: relative;

      input {
        width: 0.75em;
        max-width: 100%;
        line-height: 32px;
        padding: 0;
        margin: 0;
        border: 0 none;
        outline: none;
        font-size: 14px;
      }

      .ipt-search-val {
        position: absolute;
        top: 0;
        left: 0;
        white-space: pre;
        opacity: 0;
        pointer-events: none;
        font-size: 14px;
      }
    }

    .placeholder {
      position: absolute;
      top: 2px;
      left: 0;
      font-size: 14px;
      line-height: 32px;
    }
  }

  .options {
    margin-top: 25px;

    .student-option-list {
      overflow-y: auto;
      height: 350px;
    }

    .tit {
      line-height: 16px;
      color: #5f6368;
      font-size: 12px;
    }

    .item {
      height: 36px;
      line-height: 36px;
      padding: 0 5px;
      font-size: 0;
      margin-top: 20px;
      cursor: pointer;

      .checkbox {
        height: 20px;
        width: 20px;
        line-height: 16px;
        text-align: center;
        display: inline-block;
        border: 2px solid #5f6368;
        border-radius: 2px;
        vertical-align: middle;
        margin-right: 18px;

        .el-icon-check {
          font-size: 16px;
          color: #fff;
          display: none;
        }

        &.checked {
          border-color: #1a73e8;
          background: #1a73e8;

          .el-icon-check {
            display: block;
          }
        }
      }

      &.disabled {
        .checkbox {
          &.checked {
            border-color: #b4b4b4;
            background: #b4b4b4;

            .el-icon-check {
              display: block;
            }
          }
        }
      }

      .avatar {
        width: 32px;
        height: 32px;
        border-radius: 100%;
        background-position: center center;
        background-size: cover;
        background-repeat: no-repeat;
        background-color: #eee;
        vertical-align: middle;
        display: inline-block;
        margin-right: 18px;
        text-align: center;
        font-size: 0;
        line-height: 32px;

        .iconyiquxiao {
          vertical-align: middle;
          font-size: 18px;
        }
      }

      .icon-text {
        border-radius: 50%;
        text-align: center;
        align-items: center;
        justify-content: center;
        color: #fff;
        background: #b4b4b4;
        width: 32px;
        height: 32px;
        margin-right: 18px;
        line-height: 32px;
        font-size: 12px;
        font-family: 'opensans-semibold';
        vertical-align: middle;
        display: inline-block;
      }

      .wd {
        vertical-align: middle;
        display: inline-block;
      }

      .wd-main {
        display: flex;
        flex-direction: column;
      }

      .name {
        font-size: 14px;
        color: #202124;
        line-height: 20px;
        font-family: Roboto;
        font-weight: 500;
      }

      .mail {
        font-size: 12px;
        color: #202124;
        line-height: 16px;
        font-family: Roboto;
        font-weight: 400;
      }
    }
  }
}
</style>
